//#region Import
import React, { Component } from 'react';
/* React Router */
import { withRouter } from 'react-router-dom'

/* Redux */
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'
import { actions as modalActions } from '../../redux/ducks/modal'

/* Result */
import Result from 'iotera-base/result'

/* Template */
import Nav from '../../template/nav';
import Footer from "../../lib/components/footer/Footer";

/* Routes */
import { AppRoutes, RedirectToLogin, domainIsTenant as dit } from '../../routes/routes'

/* Json Object */
import { safeDeepGetWithType } from 'iotera-base/json'

/* Credentials Token */
import { removeTokenDit } from '../../auth/token'

/* Style */
import './app.scss';

import { LoadingBar } from 'react-redux-loading-bar';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';
//#endregion

const WKEY = 'NAV';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

class App extends Component {
  constructor(props) {
    super(props);
    // TODO get application name from API by domain
    let open = true;
    let navMini = false;
    if (window.innerWidth <= 5000) {
      open = false;
      navMini = true;
    }
    this.state = {
      logout: false,
      navMini,
      open
    }
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    // Get nav
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: '/service/web/application/nav/list/role' },
        wcallback: {
          started: function (id) {
            // TODO Loading
          },
          finished: function (id, result) {
            // TODO Loading
          }
        }
      }
    );
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  toggleNav = (e) => {
    const _this = this
    const _state = _this.state
    let navMini = !_state.navMini
    let open = !_state.open
    if (window.innerWidth <= 5000) {
      navMini = true;
    }
    _this.setState({ navMini, open });
  }

  hideNav = (e) => {
    const _this = this
    const _state = _this.state
    let navMini = _state.navMini
    let open = _state.open
    navMini = true;
    open = false;
    _this.setState({ navMini, open })
  }

  logout = (e) => {
    const _this = this
    const _props = _this.props
    const domainIsTenant = dit(_props);
    removeTokenDit(domainIsTenant);
    _this.setState({ logout: true });
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let navMini = _state.navMini
    let open = _state.open
    const { logout } = _state
    const navMap = safeDeepGetWithType(_props, ['navMap'], {});
    const appName = safeDeepGetWithType(_props, ['appName'], '');
    const navRoutes = safeDeepGetWithType(_props, ['navRoutes'], {})
    if (logout) {
      return (<RedirectToLogin {..._props} />)
    }
    // TODO Header
    return (
      <div>
        <div className="app-wrapper">
          <Nav {..._props} open={open} mini={navMini} toggleNav={_this.toggleNav} map={navMap}
            logout={_this.logout} titleHeader={appName} hideNav={_this.hideNav} />
          <div className={`content-container-custom ${navMini ? 'full' : ''}`}>
            {
              window.innerWidth <= 5000
                ?
                <div className='containers-iotera'>
                  {
                    !open ?
                      <div>
                        <div className="menu-dropshadow" style={{ display: (navMini ? 'block' : 'none') }} onClick={_this.hideNav} />
                        <LoadingBar className='loading' />
                        <AppRoutes {..._props} navMap={navRoutes} />
                      </div>
                      :
                      <React.Fragment>
                        <div className='content-iotera'>
                          <div className="menu-dropshadow" style={{ display: (navMini ? 'block' : 'none') }} onClick={_this.hideNav} />
                          <LoadingBar className='loading' />
                          <AppRoutes {..._props} navMap={navRoutes} />
                        </div>
                        <div className='middle-iotera' onClick={() => _this.toggleNav()} />
                      </React.Fragment>
                  }
                </div>
                :
                <div>
                  <div className="menu-dropshadow" style={{ display: (navMini ? 'block' : 'none') }} onClick={_this.hideNav} />
                  <LoadingBar className='loading' />
                  <AppRoutes {..._props} navMap={navRoutes} />
                </div>
            }
          </div>
        </div>
        <div className={`content-container-custom ${navMini ? 'full' : ''}`}>
          <Footer />
        </div>
      </div>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    navMap: wSelector.getSoleInitMappedRPayload(state, 'navs'),
    navRoutes: wSelector.getSoleInitMappedRPayload(state, 'navs_root'),
    appName: wSelector.getSoleInitMappedRPayload(state, 'app_name'),
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
    ...bindActionCreators(modalActions, dispatch),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));